import { Device } from '../Device'
import './styles.scss'

interface DataSourcesColumnProps {
  title: string
  children: React.ReactNode
}

function DataSourcesColumn({ title, children }: DataSourcesColumnProps) {
  const device = Device.useDevice()

  const devicePrefix = device.prefix()
  return (
    <div className={`container-column ${devicePrefix ?? 'undefined'}`}>
      <h3 className="container-column__title">{title}</h3>
      <div className="container-column__inner">{children}</div>
    </div>
  )
}

export default DataSourcesColumn
